// Spot-check flag vocabulary for External CPD (docs/modules/workflow-ld-cpd.md §4).
// The codes are computed server-side (server/services/cpdFlags.js) and stored on
// the declaration; this is the one place their wording and colours live, for
// Management → Training Records, the declaration page and the result page.

export const CPD_FLAG_META = {
  NAME_MISMATCH: { label: 'Name mismatch', hint: 'The certificate is issued to a different name' },
  FIELD_EDITED: { label: 'Edited after reading', hint: 'The declared course, date or hours differ from what was read' },
  FIELD_UNREAD: { label: 'Partly typed in', hint: 'A field could not be read and was typed in' },
  NOT_READ: { label: 'Not read', hint: 'No certificate reading — everything was typed in' },
  DUPLICATE_SUSPECT: { label: 'Duplicate suspect', hint: 'Same course on the same date, with different hours' },
};

export const CPD_FLAG_CODES = Object.keys(CPD_FLAG_META);

export const flagLabel = (code) => (CPD_FLAG_META[code] ? CPD_FLAG_META[code].label : code);

// Unconfirmed = amber (someone still has to look); confirmed = grey.
export const flagChipCls = (flag) => (flag.confirmedAt
  ? 'bg-slate-100 text-slate-600 border-slate-200'
  : 'bg-amber-50 text-amber-800 border-amber-200');

export const unconfirmedFlags = (flags = []) => flags.filter((f) => !f.confirmedAt);
